// import { useState } from "react";
import { Menu } from "antd";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/images/figo_logo.png";
import {
  FireOutlined,
  PoweroffOutlined,
  TagOutlined,
  UserOutlined,
  RocketOutlined,
  BugOutlined,
} from "@ant-design/icons";

function Sidenav({ color }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const page = pathname.replace("/", "");
  const _logout = () => {
    navigate("/sign-in");
  };
  const dashboard = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z"
        fill={color}
      ></path>
      <path
        d="M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z"
        fill={color}
      ></path>
      <path
        d="M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z"
        fill={color}
      ></path>
    </svg>,
  ];

  return (
    <>
      <div className="brand">
        <img src={logo} alt="" />
      </div>
      <hr />
      <Menu theme="light" mode="inline">
        <Menu.Item key="1">
          <NavLink to="/dashboard">
            <span
              className="icon"
              style={{
                background: page === "dashboard" ? color : "",
              }}
            >
              {dashboard}
            </span>
            <span className="label">Dashboard</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="2">
          <NavLink to="/users">
            <span
              className="icon"
              style={{
                background: page === "users" ? color : "",
              }}
            >
              <UserOutlined />
            </span>
            <span className="label">Figo Users</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="3">
          <NavLink to="/category">
            <span
              className="icon"
              style={{
                background: page === "category" ? color : "",
              }}
            >
              <TagOutlined />
            </span>
            <span className="label">Category</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="4">
          <NavLink to="/recipes">
            <span
              className="icon"
              style={{
                background: page === "recipes" ? color : "",
              }}
            >
              <FireOutlined />
            </span>
            <span className="label">Recipes</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="5">
          <NavLink to="/devices">
            <span
              className="icon"
              style={{
                background: page === "devices" ? color : "",
              }}
            >
              <RocketOutlined />
            </span>
            <span className="label">Devices</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="6">
          <NavLink to="/firmware">
            <span
              className="icon"
              style={{
                background: page === "firmware" ? color : "",
              }}
            >
              <BugOutlined />
            </span>
            <span className="label">Firmware</span>
          </NavLink>
        </Menu.Item>
      </Menu>
      <div
        className="aside-footer"
        style={{ position: "absolute", bottom: 0, cursor: "pointer" }}
        onClick={_logout}
      >
        <span className="icon">
          <PoweroffOutlined />
        </span>
        <span className="label" style={{ marginLeft: 10 }}>
          Logout
        </span>
      </div>
    </>
  );
}

export default Sidenav;
